<cc-panel-with-links-header
  [title]="titles[taskType]"
  [subtitle]="subtitles[taskType]"
  [learnMoreLink]="articleLinks[taskType]"
>
  <cc-banner
    *ngIf="isBannerVisible"
    data-test="visitor-user-plan-type-banner"
    type="warning"
    icon="warning"
    alignment="center"
    width="fit-content"
    [bannerText]="bannerText"
    customClasses="sm-mb-4"
  >
    <button class="sm-text-default-blue sm-underline" (click)="openUpgradeModal()" data-test="upgrade-button">
      {{ upgradePlanMessage }}
    </button>
  </cc-banner>
</cc-panel-with-links-header>

<div class="loading-links" *ngIf="isLoading; else loaded">
  <i class="mr-2 cc-icon cc-icon-spinner-lg"></i><span>Loading...</span>
</div>

<ng-template #loaded>
  <ng-container *ngIf="!isTeamControllerOrAbove">
    <div class="sm-flex sm-min-h-0 sm-flex-col sm-space-y-4" *ngIf="links.length > 0 || itHasTemplates">
      <cc-template-links-table
        *ngIf="links.length > 0"
        [tableLinks]="links"
        [taskType]="taskType"
        [hierarchy]="hierarchy"
        (onUnarchive)="onUnarchiveLink($event)"
        (editLink)="onEditLink($event)"
        (changeLinkData)="onChangeLinkData($event)"
      ></cc-template-links-table>

      <button
        *ngIf="canCreateLink"
        class="create-link button-regular button-green sm-h-legacy-7.2 sm-w-max"
        (click)="openCreateLinkModal()"
      >
        Create Link
      </button>
    </div>

    <div *ngIf="!itHasTemplates" class="sm-space-y-4">
      <p class="text-muted" data-test="no-templates-message">
        No Templates have been added to this team folder yet, you’ll need to do this first in order to create
        a Link.
      </p>
      <button
        data-test="go-to-templates"
        class="button-regular button-blue sm-flex sm-h-legacy-7.2 sm-flex-row sm-items-center sm-space-x-1 sm-font-medium"
        [routerLink]="['/', 'apps', 'teams', teamId]"
      >
        <span>Go to Templates</span>
        <i class="cc-icon cc-icon-arrow-long-right"></i>
      </button>
    </div>
  </ng-container>
  <ng-container *ngIf="isTeamControllerOrAbove">
    <div *ngIf="links.length > 0" class="help" i18n>
      Only users with Team Controller permissions and above can create Sitemate Links.
    </div>

    <cc-template-links-table
      *ngIf="links.length > 0"
      [tableLinks]="links"
      [hierarchy]="hierarchy"
    ></cc-template-links-table>

    <div *ngIf="links.length === 0" class="help" i18n>
      No links have been created yet. Only users with Team Controller permissions and above can create
      Sitemate Links.
    </div>
  </ng-container>
</ng-template>
